// extracted by mini-css-extract-plugin
module.exports = {"content":"SingleItemFacet_content__HYYu4","contentMobile":"SingleItemFacet_contentMobile__P_7eq"};